"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ratingIcons = exports.rating = exports.riskScoreToSeverity = exports.statusColors = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var theme_1 = require("../theme");
var svgs_1 = require("../assets/svgs");
var statusColors = function (status) {
    status = status.toLowerCase();
    switch (status) {
        case 'renewal_open':
            return theme_1.theme.palette.renewal.open;
        case 'renewal_in_progress':
            return theme_1.theme.palette.renewal.in_progress;
        case 'renewal_quoted':
            return theme_1.theme.palette.renewal.quoted;
        case 'renewal_expired':
            return theme_1.theme.palette.renewal.expired;
        case 'renewal_underwriting':
            return theme_1.theme.palette.renewal.underwriting;
        case 'renewal_declined':
            return theme_1.theme.palette.renewal.declined;
        case 'high':
            return theme_1.theme.palette.severity.high;
        case 'elevated':
            return theme_1.theme.palette.severity.elevated;
        case 'critical':
            return theme_1.theme.palette.severity.critical;
        case 'low':
            return theme_1.theme.palette.severity.low;
        case 'informational':
            return theme_1.theme.palette.severity.informational;
        case 'success':
        case 'submitted':
        case 'finished':
        case 'ready':
        case 'draft':
            return theme_1.theme.palette.success.main;
        case 'info':
        case 'low_risk':
        case 'message':
        case 'unknown':
        case 'running':
        case 'quoted':
        case 'accepted':
            return theme_1.theme.palette.info.main;
        case 'elevated_risk':
            return theme_1.theme.palette.alert.main;
        case 'alert':
        case 'medium':
        case 'warning':
        case 'high_risk':
        case 'underwriting':
        case 'pending':
            return theme_1.theme.palette.warning.main;
        case 'danger':
        case 'failed':
        case 'rejected':
        case 'voided':
        case 'canceled':
            return theme_1.theme.palette.error.main;
        case 'processing':
        case 'expired':
            return theme_1.theme.palette.primary[200];
        case 'bound':
        case 'issued':
            return theme_1.theme.palette.secondary.main;
        case 'incomplete':
            return theme_1.theme.palette.common[500];
        default:
            return theme_1.theme.palette.primary[200];
    }
};
exports.statusColors = statusColors;
/*
Risk Score to Severity Rough Mapping
informational:0-20
low:21-40
elevated: 41-60
high: 61-80
critical: 81-100
*/
var riskScoreToSeverity = function (riskScore, snoozed, isDesktop) {
    if (isDesktop === void 0) { isDesktop = false; }
    if (snoozed) {
        return {
            label: 'Snoozed',
            icon: svgs_1.StatusSnoozed,
            color: theme_1.theme.palette.primary[400],
        };
    }
    switch (true) {
        case riskScore <= 20:
            return {
                label: 'Informational',
                icon: isDesktop ? svgs_1.StatusLightBulbSmall : svgs_1.StatusLightBulb,
                color: theme_1.theme.palette.severity.informational,
            };
        case riskScore <= 40:
            return {
                label: 'Low Risk',
                icon: isDesktop ? svgs_1.StatusWarningSmall : svgs_1.StatusWarning,
                color: theme_1.theme.palette.severity.low,
            };
        case riskScore <= 60:
            return {
                label: 'Elevated Risk',
                icon: isDesktop ? svgs_1.StatusWarningSmall : svgs_1.StatusWarning,
                color: theme_1.theme.palette.severity.elevated,
            };
        case riskScore <= 80:
            return {
                label: 'High Risk',
                icon: isDesktop ? svgs_1.StatusWarningSmall : svgs_1.StatusWarning,
                color: theme_1.theme.palette.severity.high,
            };
        case riskScore <= 100:
            return {
                label: 'Critical Risk',
                icon: isDesktop ? svgs_1.StatusSkullSmall : svgs_1.StatusSkull,
                color: theme_1.theme.palette.severity.critical,
            };
        default:
            return {
                label: 'Informational',
                icon: isDesktop ? svgs_1.StatusLightBulbSmall : svgs_1.StatusLightBulb,
                color: theme_1.theme.palette.severity.informational,
            };
    }
};
exports.riskScoreToSeverity = riskScoreToSeverity;
var rating = function (i) {
    switch (true) {
        case i < 50:
            return 'Critical Risk';
        case i < 75:
            return 'Moderate Risk';
        case i < 90:
            return 'Elevated Risk';
        case i <= 100:
            return 'Low Risk';
    }
};
exports.rating = rating;
var ratingIcons = function (status) {
    status = status.toLowerCase();
    switch (status) {
        case 'success':
        case 'info':
            return (0, jsx_runtime_1.jsx)(svgs_1.StatusLightBulb, {});
        case 'message':
        case 'unknown':
        case 'alert':
        case 'warning':
        case 'low':
        case 'elevated':
        case 'medium':
        case 'high':
            return (0, jsx_runtime_1.jsx)(svgs_1.StatusWarning, {});
        case 'danger':
        case 'critical':
            return (0, jsx_runtime_1.jsx)(svgs_1.StatusSkull, {});
    }
};
exports.ratingIcons = ratingIcons;
